<template>
  <div id="service_details">
    <hr />
    <div class="row">
      <div class="col-12 bg-secondaryL p-3 my-auto">
        <h4 class="d-inline">Service Details</h4>
        <a href="#" @click="refreshTransfer">
          <img
            src="@/assets/img/refresh_icon.png"
            class="my-auto float-right d-inline"
            alt="Refesh Icon"
          />
        </a>
      </div>
    </div>

    <div class="row" v-for="(serviceDetails, index) in transferServices" :key="index">
      <div class="col-12">
        <hr />

        <div class="row mt-3">
          <div class="col-12">
            <p
              class="d-inline font-weight-bold mr-2"
              v-if="serviceDetails.Service.ServiceType == 'Gas'"
            >MPRN:</p>
            <p
              class="d-inline font-weight-bold mr-2"
              v-if="serviceDetails.Service.ServiceType == 'Electricity'"
            >MPAN:</p>
            <p class="d-inline mr-2">{{serviceDetails.Service.ServiceIdentifier}}</p>
            <p class="d-inline font-weight-bold mr-2">Address:</p>
            <p class="d-inline">{{serviceDetails.Site.Address.AddressLines[0]}}</p>
          </div>
        </div>

        <hr />

        <div
          v-if="serviceDetails.Service.ServiceType == 'Gas'
                || (serviceDetails.Service.ServiceType == 'Electricity'
                && measurementMethod(serviceDetails.MeterPoint.MeterPointConfigs) == 'NonHalfHourly')"
        >
          <!-- <gas-reading v-if="serviceDetails.Service.ServiceType == 'Gas'" :serviceDetails="serviceDetails" :serviceIndex="index" /> -->
          <div v-if="serviceDetails.Service.ServiceType == 'Gas'">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-12">
                    <h4 class="mb-4">Readings</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row pl-2">
                  <div class="col-12">
                    <p class="font-weight-bold text-left">Add Reading</p>
                  </div>
                </div>
                <div class="row pl-4 pb-4">
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Source:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <select
                      v-model="serviceDetails.ReadingSource"
                      class="form-control"
                      name="selection"
                      required
                      @change="validateGasReading(serviceDetails)"
                    >
                      <option value="AgreedOpeningRead">Agreed Opening Read</option>
                      <option value="Derived">Derived</option>
                      <option value="GasCardRead">Gas Card Read</option>
                      <option value="MeterReadOrganisation">Meter Read Organisation</option>
                      <option value="PointOfSaleRead">Point of Sale Read</option>
                      <option value="RemoteReadingEquipmentRead">Remote Reading Equipment Read</option>
                      <option value="Shipper">Shipper</option>
                      <option value="SuppliedByEndUser">Supplied by End User</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left pt-2">Reading Date:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <el-date-picker
                      v-model="serviceDetails.ReadingDate"
                      readonly
                      format="dd.MM.yyyy"
                      value-format="yyyy-MM-dd"
                      class="float-right mt-2"
                      type="date"
                      placeholder="Select end date"
                    ></el-date-picker>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left mt-2">Reading:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <div class="d-flex justify-content-start mt-2">
                      <input
                        v-for="(digit, i) in serviceDetails.CurrentMeter.Dials"
                        :key="i"
                        :ref="'gas' + index"
                        class="form-control form-control-lg font-weight-bold at_input"
                        required
                        type="text"
                        pattern="\d*"
                        maxlength="1"
                        v-model="serviceDetails.Reading[i]"
                        @keypress="autotab($event, serviceDetails, i, serviceDetails.CurrentMeter.Dials, 'Gas')"
                        @keydown.delete="reverseAutotab($event, serviceDetails, i, 'Gas')"
                        @paste="onPaste($event, serviceDetails, serviceDetails.CurrentMeter.Dials, 'Gas', 'gas' + index)"
                        @keyup="validateGasReading(serviceDetails)"
                      />
                    </div>
                  </div>
                  <div class="col-md-4 mb-2"></div>
                  <div
                    class="col-sm-8 w-100"
                    v-if="!serviceDetails.IsValidReading && (serviceDetails.Reading.length == serviceDetails.CurrentMeter.Dials) && submitStatus != 'PENDING'"
                  >
                    <div class="row">
                      <div class="col-12 mt-3">
                        <div class="row">
                          <div class="col-2 my-auto text-center">
                            <img src="@/assets/img/warning_icon.png" class="d-inline" alt="Danger" />
                          </div>
                          <div class="col-10 my-auto">
                            <p class="d-inline">
                              This isn't consistent with a value
                              we'd expect for:
                            </p>
                            <p class="d-inline ml-2">{{serviceDetails.ReadingDate | shortDate()}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-2"></div>
                  <div
                    class="col-sm-8 w-100"
                    v-if="!serviceDetails.IsValidReading && (serviceDetails.Reading.length == serviceDetails.CurrentMeter.Dials) && submitStatus != 'PENDING'"
                  >
                    <div class="row">
                      <div class="col-12 mt-3">
                        <div class="row">
                          <div class="col-10 offset-2">
                            <p class="d-inline">Submit anyway</p>
                            <div class="d-inline">
                              <span class="d-inline ml-2">
                                <label class="form-check-label radio_style">
                                  <input
                                    type="checkbox"
                                    class="form-check-input radio_style"
                                    v-model="serviceDetails.Override"
                                  />
                                  <span class="default"></span>
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 pt-1" v-if="serviceDetails.Readings.length > 0">
                <div class="row pl-2">
                  <div class="col-12">
                    <p class="font-weight-bold text-left">Latest Reading</p>
                  </div>
                </div>
                <div class="row pl-4 pb-4">
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Type:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <p
                      class="border brs pl-2 pb-1 pt-1"
                    >{{wordSplit(serviceDetails.Readings[0].ReadingType)}}</p>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Date:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <p class="border brs pl-2 pb-1 pt-1">
                      <span
                        class="ml-1"
                        v-if="serviceDetails.Readings[0].ReadingDate"
                      >{{serviceDetails.Readings[0].ReadingDate | moment("DD.MM.YY")}}</span>
                      <span
                        v-if="diff(serviceDetails.Readings[0].ReadingDate) > 25"
                        class="text-danger font-weight-bold ml-2"
                      >({{diff(serviceDetails.Readings[0].ReadingDate) | suffix}})</span>
                      <span
                        v-else-if="diff(serviceDetails.Readings[0].ReadingDate) <= 25"
                        class="text-success font-weight-bold ml-2"
                      >({{diff(serviceDetails.Readings[0].ReadingDate) | suffix}})</span>
                    </p>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <div class="d-flex justify-content-start">
                      <input
                        v-for="(digit, index) in serviceDetails.Readings[0].MeterReading.toString().padStart(serviceDetails.Meters[0].Dials, '0')"
                        :key="index"
                        class="form-control form-control-lg font-weight-bold at_input"
                        type="text"
                        maxlength="1"
                        readonly
                        :value="digit"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>

          <div v-if="serviceDetails.Service.ServiceType == 'Electricity'">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-12">
                    <h4 class="mb-4">Readings</h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row"
              v-for="(meter, meterIndex) in serviceDetails.CurrentMeters"
              :key="meterIndex"
            >
              <div class="col-md-6">
                <div class="row pl-2">
                  <div class="col-12">
                    <p class="font-weight-bold text-left">Add Reading Set</p>
                  </div>
                </div>
                <div class="row pl-4">
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Meter Serial:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <p class="text-left border brs pb-1 pt-1 pl-2">{{meter.Serial}}</p>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Date:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <el-date-picker
                      v-model="serviceDetails.ReadingDate"
                      readonly
                      format="dd.MM.yyyy"
                      value-format="yyyy-MM-dd"
                      class="float-right"
                      type="date"
                      placeholder="Select end date"
                    ></el-date-picker>
                  </div>
                  <div class="col-sm-4 mb-2">
                    <p class="font-weight-bold text-left">
                      Register Reading(s):
                    </p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <div
                      class="d-flex justify-content-start"
                      v-for="(register, registerIndex) in serviceDetails.RegisterReadings"
                      :key="registerIndex"
                    >
                      <div v-if="register.Serial == meter.Serial">
                        <!-- icon and heading -->
                        <div class="d-flex justify-content-center mt-2">
                          <i
                            class="my-auto mr-2"
                            :class="{ 'fas fa-sun': register.BillingTypeId == 'Day', 'fas fa-moon': register.BillingTypeId == 'Night', 'fas fa-couch': register.BillingTypeId == 'Weekend', 'fas fa-unlock-alt': register.BillingTypeId == 'Unrestricted' }"
                          ></i>
                          <span>{{register.BillingTypeId}}</span>
                        </div>
                        <!-- enter readings input -->
                        <div class="d-flex justify-content-center mt-2">
                          <!-- Elec new -->
                          <input
                            v-for="(digit, i) in register.Digits"
                            :key="i"
                            :ref="'elec' + index + meterIndex + registerIndex"
                            class="form-control form-control-lg font-weight-bold at_input mr-2"
                            required
                            type="text"
                            pattern="\d*"
                            maxlength="1"
                            v-model="register.Reading[i]"
                            @keypress="autotab($event, serviceDetails, i, register.Digits, 'Electricity', registerIndex)"
                            @keydown.delete="reverseAutotab($event, serviceDetails, i, 'Electricity', registerIndex)"
                            @paste="onPaste($event, serviceDetails, register.Digits, 'Electricity', 'elec' + index + meterIndex + registerIndex, registerIndex)"
                            @keyup="validateElecReadingSet(serviceDetails, meter)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-2"></div>
                  <div
                    class="col-sm-8 w-100"
                    v-if="!serviceDetails.IsValidReading && fullyPopulated(serviceDetails.RegisterReadings, meter) && submitStatus != 'PENDING'"
                  >
                    <div class="row">
                      <div class="col-12 mt-3">
                        <div class="row">
                          <div class="col-2 my-auto text-center">
                            <img src="@/assets/img/warning_icon.png" class="d-inline" alt="Danger" />
                          </div>
                          <div class="col-10 my-auto">
                            <p class="d-inline">
                              This isn't consistent with a value
                              we'd expect for:
                            </p>
                            <p class="d-inline ml-2">{{serviceDetails.ReadingDate | shortDate()}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 mb-2"></div>
                  <div
                    class="col-sm-8 w-100"
                    v-if="!serviceDetails.IsValidReading && fullyPopulated(serviceDetails.RegisterReadings, meter) && submitStatus != 'PENDING'"
                  >
                    <div class="row">
                      <div class="col-12 mt-3">
                        <div class="row">
                          <div class="col-10 offset-2">
                            <p class="d-inline">Submit anyway</p>
                            <div class="d-inline">
                              <span class="d-inline ml-2">
                                <label class="form-check-label radio_style">
                                  <input
                                    type="checkbox"
                                    class="form-check-input radio_style"
                                    v-model="serviceDetails.Override"
                                  />
                                  <span class="default"></span>
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row pl-2">
                  <div class="col-12">
                    <p class="font-weight-bold text-left">Latest Reading Set</p>
                  </div>
                </div>
                <div class="row pl-4 pb-4" v-if="latestReading(serviceDetails.Readings, meter)">
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Type:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <p
                      class="border brs pl-2 pb-1 pt-1"
                    >{{wordSplit(latestReading(serviceDetails.Readings, meter).ReadingType)}}</p>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Reading Date:</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <p class="border brs pl-2 pb-1 pt-1">
                      <span
                        class="ml-1"
                        v-if="latestReading(serviceDetails.Readings, meter).ReadingDate"
                      >{{latestReading(serviceDetails.Readings, meter).ReadingDate | moment("DD.MM.YY")}}</span>
                      <span
                        v-if="diff(latestReading(serviceDetails.Readings, meter).ReadingDate) > 25"
                        class="text-danger font-weight-bold ml-2"
                      >({{diff(latestReading(serviceDetails.Readings, meter).ReadingDate) | suffix}})</span>
                      <span
                        v-else-if="diff(latestReading(serviceDetails.Readings, meter).ReadingDate) <= 25"
                        class="text-success font-weight-bold ml-2"
                      >({{diff(latestReading(serviceDetails.Readings, meter).ReadingDate) | suffix}})</span>
                    </p>
                  </div>
                  <div class="col-sm-4">
                    <p class="font-weight-bold text-left">Register Reading(s):</p>
                  </div>
                  <div class="col-8 col-sm-6 w-100">
                    <div
                      class="d-flex justify-content-start"
                      v-for="(registerReading, index) in latestReading(serviceDetails.Readings, meter).RegisterReadings"
                      :key="index"
                    >
                      <div
                        v-if="findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).IsSettlement"
                      >
                        <div class="d-flex justify-content-center mt-2">
                          <i
                            class="my-auto mr-2"
                            :class="{ 'fas fa-sun': findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).BillingTypeId == 'Day', 'fas fa-moon': findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).BillingTypeId == 'Night', 'fas fa-couch': findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).BillingTypeId == 'Weekend', 'fas fa-unlock-alt': findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).BillingTypeId == 'Unrestricted' }"
                          ></i>
                          <span>{{findRegister(meter.MeterConfigs, registerReading.MeterRegisterId).BillingTypeId}}</span>
                        </div>

                        <div class="d-flex justify-content-center mt-2">
                          <input
                            v-for="(digit, index) in splitReading(registerReading, meter.MeterConfigs)"
                            :key="index"
                            class="form-control form-control-lg font-weight-bold at_input mr-2"
                            type="text"
                            maxlength="1"
                            readonly
                            :value="digit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-12 mt-4">
                    <div class="h-100">
                      <div class="d-flex h-100 justify-content-center align-items-center">
                        <img
                          src="@/assets/img/tick_selector.png"
                          class="img-fluid d-inline-block"
                          alt="No charges have been applied to this account"
                        />
                        <p class="d-inline-block my-auto pl-2">
                          No readings have been added to
                          date.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>

        <!-- row close -->
        <div class="row pt-2 pb-4">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <h4>Priority Services</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold text-left pl-2">Add Vulnerabilities</p>
              </div>
              <div class="col-md-6 col-xl-7">
                <b-form-select v-model="psrType" class="mb-3">
                  <option :value="null"></option>
                  <option value="AdditionalPresencePreferred">Additional Presence Preferred</option>
                  <option value="Blind">Blind</option>
                  <option value="CarelineTelecareSystem">Careline Telecare System</option>
                  <option value="ChronicSeriousIllness">Chronic Serious Illness</option>
                  <option value="Dementia">Dementia</option>
                  <option value="DevelopmentalCondition">Developmental Condition</option>
                  <option value="DialysisFeedingPumpAndAutomatedMedication">
                    Dialysis
                    Feeding Pump
                    And
                    Automated Medication
                  </option>
                  <option value="FamiliesWithYoungChildren5OrUnder">
                    Families With
                    Young Children 5
                    Or
                    Under
                  </option>
                  <option value="HearingSpeechDifficulties">Hearing Speech Difficulties</option>
                  <option value="HeartLungAndVentilator">Heart Lung And Ventilator</option>
                  <option value="MdeElectricityShowering">Mde Electricity Showering</option>
                  <option value="MedicineRefrigeration">Medicine Refrigeration</option>
                  <option value="MentalHealth">Mental Health</option>
                  <option value="NebuliserAndApnoeaMonitor">
                    Nebuliser And Apnoea
                    Monitor
                  </option>
                  <option value="OxygenConcentrator">Oxygen Concentrator</option>
                  <option value="OxygenUse">Oxygen Use</option>
                  <option value="PartiallySighted">Partially Sighted</option>
                  <option value="PensionableAge">Pensionable Age</option>
                  <option value="PhysicalImpairment">Physical Impairment</option>
                  <option value="PoorSenseOfSmell">Poor Sense Of Smell</option>
                  <option value="RestrictedHandMovement">Restricted Hand Movement</option>
                  <option value="StairliftHoistElectricBed">
                    Stairlift Hoist Electric
                    Bed
                  </option>
                  <option value="TemporaryLifeChanges">Temporary Life Changes</option>
                  <option value="TemporaryPostHospitalRecovery">
                    Temporary Post
                    Hospital Recovery
                  </option>
                  <option value="TemporaryYoungAdultHouseholder">
                    Temporary Young Adult
                    Householder
                  </option>
                  <option value="UnableToAnswerDoorRestrictedMovement">
                    Unable To
                    Answer Door
                    Restricted Movement
                  </option>
                  <option value="UnableToCommunicateInEnglish">
                    Unable To Communicate
                    In English
                  </option>
                </b-form-select>
              </div>
              <div class="col-md-6 col-xl-5">
                <div>
                  <el-date-picker
                    v-model="effectiveFromDate"
                    format="dd.MM.yyyy"
                    class="float-right mb-2"
                    type="date"
                    placeholder="Start date"
                    :clearable="false"
                  ></el-date-picker>
                </div>
                <div>
                  <el-date-picker
                    v-model="effectiveToDate"
                    format="dd.MM.yyyy"
                    class="float-right"
                    type="date"
                    placeholder="End date"
                  ></el-date-picker>
                </div>
              </div>
            </div>
            <!-- row close -->
            <div class="form-group shadow-textarea text-left">
              <p class="mb--20 mt-2 mb-2">
                <label for="exampleFormControlTextarea6" class="font-weight-bold pl-2">Notes:</label>
              </p>
              <textarea
                v-model="psrSpecificDetails"
                class="form-control z-depth-1"
                id="exampleFormControlTextarea10"
                rows="5"
              ></textarea>
            </div>
            <div class="row">
              <div class="col-12">
                <a
                  href="#"
                  role="button"
                  class="btn btn-hc mb-2 float-right"
                  @click="addPriorityService(index)"
                >
                  Add
                  Vulnerability
                </a>
              </div>
              <div class="col-11 text-left">
                <ul class="dashed">
                  <li
                    class="mb-2"
                    v-for="(service, index) in serviceDetails.PriorityServices"
                    :key="index"
                  >
                    <span class="d-inline">
                      {{wordSplit(service.PsrType)}}
                      <span>
                        ({{service.EffectiveFromDate | moment('DD.MM.YYYY')}}
                        <span
                          v-if="service.EffectiveToDate"
                        >
                          -
                          {{service.EffectiveToDate | moment('DD.MM.YYYY')}}
                        </span>
                        <span v-else>- N/A</span>
                        )
                      </span>
                      <span
                        v-if="service.PsrSpecificDetails"
                        v-b-popover.hover.topright="service.PsrSpecificDetails"
                        title="Notes"
                        class="pointer"
                      >
                        <i class="fas fa-sticky-note ml-2"></i>
                        <i class="fas fa-pencil-alt"></i>
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <h4>Commercial Configuration</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold text-left pl-2">Commercial %</p>
              </div>
              <div class="col-12">
                <!-- Here is a link to the slider working -->
                <!-- https://jsfiddle.net/Rick1107/tc0neuzx/3/ -->
                <div>
                  <input
                    type="range"
                    class="w-75 slider"
                    min="0"
                    max="100"
                    step="1"
                    v-model="serviceDetails.Commercial"
                  />
                  <input
                    type="number"
                    class="w-20 border border-secondary brs ml-3 text-center"
                    v-model="serviceDetails.Commercial"
                  />
                  <!-- must have a % sign after the integer and must default to 100%-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold text-left pl-2">CCL Exemption Type</p>
              </div>
              <div class="col-12">
                <div class="btn-group d-block w-100">
                  <div class="form-group my-auto">
                    <b-form-select
                      v-model="serviceDetails.ExemptionType"
                      class="form-control"
                      name="selection"
                      required
                    >
                      <option value="NotExempt">Not Exempt</option>
                      <option value="Charity">Charity</option>
                      <option value="Domestic">Domestic</option>
                      <option value="Usage">Usage</option>
                      <option value="ClimateChangeAgreementInPlace">
                        Climate
                        change agreement
                        in
                        place
                      </option>
                    </b-form-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-4">
                <p class="font-weight-bold text-left pl-2">CCA Reduction %</p>
              </div>
              <div class="col-12">
                <!-- Here is a link to the slider working -->
                <!-- https://jsfiddle.net/Rick1107/tc0neuzx/3/ -->
                <div>
                  <input
                    type="range"
                    class="w-75 slider"
                    min="0"
                    max="100"
                    step="1"
                    v-model="serviceDetails.CCA"
                  />
                  <input
                    type="number"
                    class="w-20 border border-secondary brs ml-3 text-center"
                    v-model="serviceDetails.CCA"
                  />
                  <!-- must have a % sign after the integer and defaults to 0-->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="font-weight-bold text-left pl-2 mt-4">CCA Description</p>
              </div>
              <div class="col-12">
                <textarea
                  v-model="serviceDetails.CCADescription"
                  class="form-control z-depth-1"
                  id="exampleFormControlTextarea5"
                  rows="5"
                ></textarea>
              </div>
            </div>

            <div v-if="serviceDetails.Service.ServiceType == 'Gas'">
              <div class="row">
                <div class="col-12">
                  <p class="font-weight-bold text-left pl-2">Billing AQ</p>
                </div>
                <div class="col-12">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-input v-model="serviceDetails.BillingAq" type="text"></b-form-input>
                    </div>
                  </div>
                </div>
              </div>
              <!-- This is only shown if billing aq is applied. If not do not show this dropdown -->
              <div class="row" v-if="serviceDetails.BillingAq">
                <div class="col-12">
                  <p class="font-weight-bold text-left pl-2 mt-4">Application Rule</p>
                </div>
                <div class="col-12">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-select
                        v-model="serviceDetails.ApplicationRule"
                        class="form-control"
                        name="selection"
                        required
                      >
                        <option value="WhenBillingIsHigherThanIndustry">
                          Higher
                          than industry
                        </option>
                        <option value="WhenBillingIsLowerThanIndustry">
                          Lower
                          than industry
                        </option>
                        <option value="Always">Always</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="serviceDetails.Service.ServiceType == 'Electricity'">
              <div class="row">
                <div class="col-12">
                  <p class="font-weight-bold text-left pl-2 mt-4">EAC Level</p>
                </div>
                <div class="col-12">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-select
                        v-model="serviceDetails.EacLevel"
                        class="form-control"
                        name="selection"
                        required
                        @input="selectEacLevel($event, index)"
                      >
                        <option :value="null"></option>
                        <option value="MeterPoint">Meter Point</option>
                        <option value="Register">Register</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-4" v-if="serviceDetails.EacLevel">
                <div class="col-12">
                  <p
                    class="font-weight-bold text-left pl-2"
                    v-if="serviceDetails.EacLevel == 'MeterPoint'"
                  >
                    Billing
                    EAC
                  </p>
                  <p
                    class="font-weight-bold text-left pl-2"
                    v-if="serviceDetails.EacLevel == 'Register'"
                  >Billing EACs</p>
                </div>
                <div class="col-12" v-if="serviceDetails.EacLevel == 'MeterPoint'">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-input v-model="serviceDetails.MeterPointBillingEac" type="text"></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="serviceDetails.EacLevel == 'Register'">
                  <div class="btn-group d-block w-100">
                    <div
                      class="form-group my-auto"
                      v-for="(eac, i) in serviceDetails.BillingEac"
                      :key="i"
                    >
                      <label class="pl-2 pt-1" :for="eac.RegisterId">
                        Register:
                        {{eac.RegisterId}}
                      </label>
                      <b-form-input :id="eac.RegisterId" v-model="eac.BillingEac" type="text" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="serviceDetails.EacLevel">
                <div class="col-12">
                  <p class="font-weight-bold text-left pl-2 mt-4">Application Rule</p>
                </div>
                <div class="col-12">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-select
                        v-model="serviceDetails.ApplicationRule"
                        class="form-control"
                        name="selection"
                        required
                      >
                        <option value="WhenBillingIsHigherThanIndustry">
                          Higher
                          than industry
                        </option>
                        <option value="WhenBillingIsLowerThanIndustry">
                          Lower
                          than industry
                        </option>
                        <option value="Always">Always</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
              </div>
                           
              <div class="row" v-if="serviceDetails.MeasurementMethod =='HalfHourly'">
                <div class="col-12">
                  <p class="font-weight-bold text-left pl-2 mt-4">HH NHH Mapping</p>
                </div>
                <div class="col-12">
                  <div class="btn-group d-block w-100">
                    <div class="form-group my-auto">
                      <b-form-select
                        v-model="serviceDetails.HHNHHMappingType"
                        class="form-control"
                        name="selection"
                        required
                        @input="selectEacLevel($event, index)"
                      >
                        <option :value="null">Not Applicable</option>
                        <option v-for="mapping in HHNHHMappings" :key="mapping.value" :value="mapping.value">{{mapping.label}}</option>
                      </b-form-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-hc float-right" @click="back">
        <i class="fas fa-caret-left"></i>
        Back
      </button>
      <button type="submit" class="btn btn-hc float-right" @click="next" :disabled="mappingInvalid">
        Next
        <i class="fas fa-caret-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { uuid } from 'vue-uuid';
import { _ } from 'vue-underscore';

// Components
// import GasReading from './components/GasReading'

// Mixins
import _filters from '@/mixins/filters.js';
import snotifyHttpError from '@/mixins/snotifyHttpResponses';

export default {
  mixins: [_filters, snotifyHttpError],
  // components: {GasReading},
  data() {
    return {
      effectiveFromDate: moment.utc().format(),
      effectiveToDate: null,
      psrType: null,
      psrSpecificDetails: undefined,
      submitStatus: null,
    };
  },
  methods: {
    latestReading(readings, meter) {
      return _.sortBy(
        _.where(readings, {
          Serial: meter.Serial,
        }),
        'ReadingDate'
      ).reverse()[0];
    },
    measurementMethod(configs) {
      return _.sortBy(configs, 'EffectiveFrom').reverse()[0].MeasurementMethod;
    },
    selectEacLevel(e, i) {
      this.transferServices[i].MeterPointBillingEac = null;
      this.transferServices[i].BillingEac.forEach((eac) => {
        eac.BillingEac = null;
      });
      return;
    },
    findRegister(configs, meterRegisterId) {
      var config = _.sortBy(configs, 'EffectiveFrom').reverse()[0];
      return _.findWhere(config.Registers, {
        RegisterId: meterRegisterId,
      });
    },
    splitReading(registerReading, configs) {
      return registerReading.Reading.toString(10)
        .padStart(
          this.findRegister(configs, registerReading.MeterRegisterId).Digits,
          '0'
        )
        .split('')
        .map(Number);
    },
    refreshTransfer() {
      this.$store.commit('refreshTransfer');
    },
    diff: function(readingDate) {
      return moment().diff(readingDate, 'days');
    },
    next() {
      for (let index = 0; index < this.transferServices.length; index++) {
        var sd = this.transferServices[index];
        if (!sd.IsValidReading && !sd.Override) return;
        if (
          sd.Service.ServiceType == 'Gas' &&
          sd.Reading.length != sd.CurrentMeter.Dials
        )
          return;
        if (
          sd.Service.ServiceType == 'Electricity' &&
          sd.MeasurementMethod == 'NonHalfHourly'
        ) {
          var rr = sd.RegisterReadings;
          for (let i = 0; i < rr.length; i++) {
            if (rr[i].Reading.length != rr[i].Digits) return;
          }
        }
      }
      this.$emit('next');
    },
    back() {
      this.$emit('back');
    },
    onPaste(e, serviceDetails, digits, serviceType, ref, rrIndex) {
      var pastedData = e.clipboardData
        .getData('Text')
        .replace(/[^0-9]+/g, '')
        .trim()
        .padStart(digits, '0')
        .split('')
        .map(Number);
      window.setTimeout(() => {
        // Do something immediately after the paste
        serviceType == 'Gas'
          ? (serviceDetails.Reading = [])
          : (serviceDetails.RegisterReadings[rrIndex].Reading = []);

        for (let index = 0; index < digits; index++) {
          serviceType == 'Gas'
            ? (serviceDetails.Reading[index] = pastedData[index])
            : (serviceDetails.RegisterReadings[rrIndex].Reading[index] =
                pastedData[index]);
        }

        this.$refs[ref][digits - 1].focus();
      });
    },
    autotab($event, serviceDetails, index, digits, serviceType, rrIndex) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode > 47 && keyCode < 58) {
        if (serviceType == 'Gas') {
          if (serviceDetails.Reading.length < digits) {
            if (
              serviceDetails.Reading[index] != undefined ||
              serviceDetails.Reading[index] != ''
            ) {
              serviceDetails.Reading.push($event.key);
            }
          }
        }
        if (serviceType == 'Electricity') {
          if (
            serviceDetails.RegisterReadings[rrIndex].Reading.length < digits
          ) {
            if (
              serviceDetails.RegisterReadings[rrIndex].Reading[index] !=
                undefined ||
              serviceDetails.RegisterReadings[rrIndex].Reading[index] != ''
            ) {
              serviceDetails.RegisterReadings[rrIndex].Reading.push($event.key);
            }
          }
        }
        return $event.target.nextElementSibling.focus();
      }
      return $event.preventDefault();
    },
    reverseAutotab($event, serviceDetails, index, serviceType, rrIndex) {
      $event.preventDefault();
      serviceType == 'Gas'
        ? serviceDetails.Reading.splice(index, 1)
        : serviceDetails.RegisterReadings[rrIndex].Reading.splice(index, 1);
      return $event.target.previousElementSibling.focus();
    },
    addPriorityService(i) {
      if (this.psrType) {
        this.transferServices[i].PriorityServices.push({
          EffectiveFromDate: moment.utc(this.effectiveFromDate).format(),
          EffectiveToDate: this.effectiveToDate
            ? moment.utc(this.effectiveToDate).format()
            : undefined,
          PsrSpecificDetails:
            this.psrSpecificDetails != '' ? this.psrSpecificDetails : undefined,
          PsrType: this.psrType,
        });
        this.effectiveFromDate = moment.utc().format();
        this.effectiveToDate = null;
        this.psrType = null;
        this.psrSpecificDetails = undefined;
      }
    },
    validateGasReading(serviceDetails) {
      this.submitStatus = 'PENDING';
      if (serviceDetails.Reading.length == serviceDetails.CurrentMeter.Dials) {
        this.$snotify.async(
          'Validating reading...',
          () =>
            new Promise((resolve, reject) => {
              this.$http
                .post(
                  'https://' +
                    Vue.config.honeycomb.readingsbot.gas.domain +
                    '/api/v1/readings/validate',
                  {
                    SharedId: uuid.v1(),
                    Mprn: serviceDetails.Service.ServiceIdentifier,
                    Serial: serviceDetails.CurrentMeter.Serial,
                    ReadingDate: serviceDetails.ReadingDate,
                    MeterReading: parseInt(
                      serviceDetails.Reading.toString().replace(/,/g, '')
                    ),
                    ReadingSource: 'SuppliedByEndUser',
                    IsChangeOfTenancy: true,
                  },
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  this.submitStatus = 'OK';
                  if (response.data.hasOwnProperty('IsValid')) {
                    serviceDetails.IsValidReading = response.data.IsValid;
                    serviceDetails.Override = false;
                    if (response.data.IsValid) {
                      resolve({
                        body: 'Reading validated.',
                        config: {
                          closeOnClick: true,
                          timeout: 2000,
                        },
                      });
                    } else {
                      reject({
                        body: 'Reading invalid.',
                        config: {
                          closeOnClick: true,
                          timeout: 2000,
                        },
                      });
                    }
                  }
                })
                .catch((error) => {
                  // Error
                  this.submitStatus = 'Error';
                  serviceDetails.IsValidReading = false;
                  serviceDetails.Override = false;
                  reject(this.snotifyHttpError(error));
                });
            })
        );
      }
    },
    validateElecReadingSet(serviceDetails, meter) {
      this.submitStatus = 'PENDING';
      if (this.fullyPopulated(serviceDetails.RegisterReadings, meter)) {
        this.$snotify.async(
          'Validating reading set...',
          () =>
            new Promise((resolve, reject) => {
              this.$http
                .post(
                  'https://' +
                    Vue.config.honeycomb.readingsbot.electricity.domain +
                    '/api/v1/readings/validate',
                  {
                    Mpan: serviceDetails.Service.ServiceIdentifier,
                    Serial: meter.Serial,
                    ReadingDate: serviceDetails.ReadingDate,
                    ReadingType: serviceDetails.ReadingType,
                    RegisterReadings: this.formatRegisterReadings(
                      serviceDetails.RegisterReadings,
                      meter
                    ),
                    IsChangeOfTenancy: true,
                  },
                  {
                    withCredentials: true,
                  }
                )
                .then((response) => {
                  this.submitStatus = 'OK';
                  if (response.data.hasOwnProperty('IsValid')) {
                    serviceDetails.IsValidReading = response.data.IsValid;
                    serviceDetails.Override = false;
                    if (response.data.IsValid) {
                      resolve({
                        body: 'Reading set validated.',
                        config: {
                          closeOnClick: true,
                          timeout: 2000,
                        },
                      });
                    } else {
                      reject({
                        body: 'Reading set invalid.',
                        config: {
                          closeOnClick: true,
                          timeout: 2000,
                        },
                      });
                    }
                  }
                })
                .catch((error) => {
                  // Error
                  this.submitStatus = 'Error';
                  serviceDetails.IsValidReading = false;
                  serviceDetails.Override = false;
                  reject(this.snotifyHttpError(error));
                });
            })
        );
      }
    },
    filterRegisterReadings(registerReadings, meter) {
      return _.filter(registerReadings, function(rr) {
        return rr.Serial == meter.Serial;
      });
    },
    fullyPopulated(registerReadings, meter) {
      var rrCount = this.filterRegisterReadings(registerReadings, meter).length;

      var populatedCount = 0;

      registerReadings.forEach((rr) => {
        if (rr.Serial == meter.Serial && rr.Reading.length == rr.Digits) {
          populatedCount++;
        }
      });

      return populatedCount == rrCount;
    },
    formatRegisterReadings(registerReadings, meter) {
      var filteredRegisterReadings = this.filterRegisterReadings(
        registerReadings,
        meter
      );
      var formattedRegisterReadings = [];

      filteredRegisterReadings.forEach((rr) => {
        if (rr.Reading.length > 0) {
          var r = rr.Reading.toString();
          r = +parseFloat(r.replace(/,/g, '')).toFixed(2);

          formattedRegisterReadings.push({
            Reading: r,
            MeterRegisterId: rr.MeterRegisterId,
            IsValid: rr.IsValid,
          });
        }
      });

      return formattedRegisterReadings;
    },
  },
  computed: {
    transferServices: {
      get() {
        return this.$store.state.transfer.transferServices;
      },
      set(details) {
        this.$store.commit('updateServiceDetails', details);
      },
    },
    createCustomer() {
      return this.$store.state.transfer.createCustomer;
    },
    destinationCustomer() {
      return this.$store.state.transfer.destinationCustomer;
    },
    transferDate() {
      return this.$store.state.transfer.transferDate;
    },
    HHNHHMappings() {
      return this.$store.state.contracts.hhnhhmappings.filter(
        (m) => m.isVisible
      );
    },
    serviceBundle: {
      get() {
        return this.$store.state.transfer.serviceBundle;
      },
    },

    hhTariffs() {
      const serviceBundle = this.$store.state.transfer.serviceBundle;

      if (!serviceBundle || !serviceBundle.TariffVersions) {
        return [];
      }

      return this.$store.state.transfer.serviceBundle.TariffVersions.filter(
        (p) =>
          moment(this.$store.state.transfer.transferDate).isBetween(
            p.EffectiveFrom,
            p.EffectiveTo
          ) && p.HhElectricityDetails.length
      );
    },

    mappingInvalid() {
      return this.transferServices.some((service) => {
        return (
          service.MeasurementMethod == 'HalfHourly' && // service is hh
          !this.hhTariffs.length && // service bundle is not hh
          service.HHNHHMappingType === undefined // no mapping selection made (undefined means not selected, null means "Not Applicable")
        );
      });
    },
  },
};
</script>
